import { Component, Input } from '@angular/core';
import { ModalService } from '@src/shared/modal/modal.service';
import { saveFileAs } from '../../../utils/files';
import { OutcomeReportsService } from '../../../woo_services.module/OutcomeReportsService';
import { wooId } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'download-outcome-button',
  template: `
    <button class="link text--semi-strong margin--none padding--none" (click)="download()">
      <span class="icon-download"></span> Ladda ner slutstatistik
    </button>
  `,
  standalone: false,
})
export class DownloadOutcomeButton {
  @Input() campaignId: wooId;
  @Input() campaignName: wooId;

  constructor(private outcomeReportsService: OutcomeReportsService, private modalService: ModalService) {}

  download = (): void => {
    const loaderModal = this.modalService.openLoader('Skapar fil');
    this.outcomeReportsService
      .summaryExport(this.campaignId)
      .then(
        (data) => {
          loaderModal.close();
          saveFileAs(data, `Slutstatistik - ${this.campaignName}.xlsx`);
        },
        () => {
          this.modalService.openError('Det finns ingen statistik för vald kampanj.');
        },
      )
      .finally(() => {
        loaderModal.close();
      });
  };
}
